import { Button, Grid, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import AdminContentFilter from '../../../../../shared/components/filters/AdminContentFilter'
import CountriesFilter from '../../../../../shared/components/filters/CountryFilter'
import { tableScreenStyles } from '../../../../../shared/styles/TableScreenStyles'

interface ActionButtonsProps {
  handleCreateNews: () => void
  optionsData: any[]
  handleClickSetOptions: (options: any) => void
}

export const ActionButtons = ({ handleCreateNews, optionsData, handleClickSetOptions }: ActionButtonsProps) => {
  const { t } = useTranslation(['global'])
  const theme = useTheme()
  const tableclass = tableScreenStyles(theme)

  return (
    <Grid container justifyContent="space-between" spacing={1}>
      <Grid item xs={5} sm={6} sx={tableclass.actionsResponsive}>
        <Button variant="outlined" color="secondary" onClick={handleCreateNews}>
          {`${t('create')} ${t('news')}`}
        </Button>
      </Grid>
      <Grid item xs={7} sm={6} sx={tableclass.actionsResponsiveRight}>
        <AdminContentFilter data={optionsData} handleClick={handleClickSetOptions} />
        <CountriesFilter />
      </Grid>
    </Grid>
  )
}
